/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { API_PATH } from "src/environments/config";

@Injectable({
  providedIn: "root",
})
export class BusinessUnitsApiService {
  constructor(public http: HttpClient) {}
  getBusinessUnitsByPage(data) {
    let httpParams = new HttpParams();
    httpParams = data.page ? httpParams.set("page", data.page) : httpParams;
    httpParams = data.limit ? httpParams.set("limit", data.limit) : httpParams;
    httpParams = data.searchText
      ? httpParams.set("searchText", data.searchText).set("searchField", "name")
      : httpParams;
    return this.http.get<any>(API_PATH.apis.businessUnits, {
      params: httpParams,
    });
  }
  getCompanyBusinessUnitName() {
    return this.http.get<any>(API_PATH.apis.getBusinessUnitsByCompany);
  }
  whiteShopBusinessUnitSetting(data) {
    return this.http.put<any>(
      API_PATH.apis.businessUnits + "/" + data.id,
      data
    );
  }
  getCompanyIncharges(id) {
    return this.http.get<any>(API_PATH.apis.companyInchargeUsers + id);
  }
  createBusinessUnit(data) {
    return this.http.post<any>(API_PATH.apis.businessUnits, data);
  }
  getCompanyInfo(companyId) {
    return this.http.get<any>(API_PATH.apis.server + "/companies/" + companyId);
  }
  updateBusinessUnit(data, id) {
    return this.http.put<any>(API_PATH.apis.businessUnits + "/" + id, data);
  }

  getBusinessUnitDetails(data) {
    return this.http.get<any>(API_PATH.apis.businessUnitDetails + data);
  }
  updateSettings(data) {
    return this.http.put<any>(API_PATH.apis.updateSettings, data);
  }
  getPickupLocations() {
    return this.http.get<any>(API_PATH.apis.server + "/getPickupLocations");
  }
  getPaymentTerms() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("isBusinessUnit", "true");
    httpParams = httpParams.set(
      "paymentCompanyId",
      this.getCurrentBusinessUnit()
    );
    return this.http.get<any>(API_PATH.paymentAPI.companyPaymentTerms, {
      params: httpParams,
    });
  }
  getCurrentBusinessUnit() {
    return JSON.parse(sessionStorage.getItem("currentBusinessUnit"))._id;
  }
  getPaymentModes() {
    let httpParams = new HttpParams();
    httpParams = httpParams.set("isBusinessUnit", "true");
    httpParams = httpParams.set(
      "paymentCompanyId",
      this.getCurrentBusinessUnit()
    );
    return this.http.get<any>(API_PATH.paymentAPI.companyPaymentModes, {
      params: httpParams,
    });
  }
  getCompanySettingsInfo(companyId?, isSegments?) {
    if (companyId) {
      let httpParams = new HttpParams();
      httpParams = httpParams.set("companyId", companyId);
      return this.http.get<any>(API_PATH.apis.server + "/companySettingsData", {
        params: httpParams,
      });
    } else if (isSegments) {
      let httpParams = new HttpParams();
      httpParams = httpParams.set("isSegments", "true");
      return this.http.get<any>(API_PATH.apis.server + "/companySettingsData", {
        params: httpParams,
      });
    } else {
      return this.http.get<any>(API_PATH.apis.server + "/companySettingsData");
    }
  }
}
